import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Link, Redirect } from 'react-router-dom';
import { researchData } from '../data';
import { publishedData } from '../data';
import { AustraliaMap } from '../shared';

import { PublishedItem } from '../components/Publications/PublishedItem';

export default class ResearchDetail extends React.Component<any, any> {


    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        window.scrollTo(0,0);
    }
    componentDidUpdate(prevProps, prevState){
        window.scrollTo(0, 0);
    }

    render() {
        let researchKey = this.props.location.hash.replace('#', '');
        // Add redirect here for old links
        if (!researchKey || researchKey.length == 0) {
            return  (
                <Redirect to={`/Projects`} />
            );
        }
        return (
            <Redirect to={'/ProjectItem/' + researchKey } />
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/ResearchDetail.tsx